import {
  ActionIcon,
  Divider,
  Group,
  Stack,
  Text,
  ThemeIcon,
  Tooltip,
} from "@mantine/core";
import FoldersListing from "../lists/ListingWithContent/contacts/FoldersListing";
import { IconArrowLeft, IconFolders, IconSwitchVertical } from "@tabler/icons-react";
import FolderAdder from "../lists/ListingWithContent/contacts/FolderAdder";
import { useListStore } from "../../../stores/ListStore";
import { Link, useNavigate } from "react-router-dom";

const FileFolders = () => {
  const navigate = useNavigate();
  const handleSwap = () => {
    navigate("/settings/tools/files/");
  };

  return (
    <Stack
      pos={"relative"}
      w={"100%"}
      mr={16}
      pt={16}
      pr={48}
      h={"calc(100vh - 96px)"}
    >
      <Group gap={"md"}>
        <ActionIcon size={"xl"} component={Link} to={"/settings/tools/"}>
          <IconArrowLeft />
        </ActionIcon>
        <Text size="xl" fw={600}>
          Mes dossiers
        </Text>
        <Tooltip label={`Basculer vers "Mes fichiers"`}>
          <ActionIcon
            variant="light"
            size={"lg"}
            onClick={handleSwap}
            mr={"auto"}
          >
            <IconSwitchVertical />
          </ActionIcon>
        </Tooltip>

        <FolderAdder
          type={"File"}
          onFinish={() => useListStore.getState().setListingLoad(true)}
          isButton
        />
      </Group>
      <Divider />
      <FoldersListing
        type="File"
        mainUrl="/settings/tools/files"
        keyword="file"
      />
    </Stack>
  );
};

export default FileFolders;
